import Markdown from "../markdown"
import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const Card = styled.a`
  background-color: white;
  border: 1px solid ${({ theme }) => theme.colors.primary};
  border-radius: 1rem;
  overflow: hidden;
  box-sizing: border-box;
  margin-bottom: 1rem;
  margin-top: 1.2rem;
  display: flex;

  background-color: #f6f6f6;
  text-decoration: none;
  cursor: default;

  ${({ alert }) =>
    !!alert &&
    `
    border-color: #ffb20f;
    background-color: rgba(255, 178, 15, 0.2);
    `}

  ${({ href }) =>
    !!href &&
    href.length > 1 &&
    `
    cursor: pointer;

    &:hover {
      a {
        text-decoration: underline;
      }
    }
  `}

  ${breakpoint("tablet")`
    margin-top: 0;
    margin-bottom: 2rem;
  `}

  ${({ mobileOnly }) =>
    !!mobileOnly &&
    breakpoint("tablet")`
    display: none;
  `}

  ${({ desktopOnly }) =>
    !!desktopOnly &&
    css`
      display: none;

      ${breakpoint("tablet")`
      display: grid;
    `}
    `}
`

export const Img = styled.img`
  background-color: ${({ theme }) => theme.colors.primary};
  width: 33%;
  object-fit: cover;
`

export const Content = styled.div`
  flex: 1;

  color: ${({ theme }) => theme.colors.body};
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
`

export const StyledContent = styled(Markdown)`
  display: block;
  padding: 0;
  margin: 1rem;

  a {
    color: ${({ theme }) => theme.colors.primary};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`

export const StyledLink = styled.a`
  display: block;
  margin: 0 1rem 1rem;

  color: ${({ theme }) => theme.colors.primary};
  text-decoration: none;

  svg {
    font-size: 0.8rem;
  }
  span {
    margin-right: 0.25rem;
  }
`
